import { render, staticRenderFns } from "./InsurancesPlans.vue?vue&type=template&id=5dc0421a&"
import script from "./InsurancesPlans.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports